import '../assets/scripts/main';
import '../assets/scripts/swiper';
import '../assets/scripts/footer';
